import type { MutablePoint } from "./projection.ts";

/**
 * The things the scene draws, as world-attached UI reads them (ADR-058's amendment for P2.2-T7): where the top of a
 * thing's art is drawn, so a number the player dealt to a training dummy rises over it as one dealt to a character
 * rises over its head. Reading it allocates nothing.
 */
export interface ThingSource {
  /**
   * Where the top of a thing's art is drawn, centred across its frame.
   *
   * @param handle The thing's handle.
   * @param out Where to write it, in world pixels.
   * @returns False when no thing of that handle is drawn.
   */
  top(handle: number, out: MutablePoint): boolean;
}

/**
 * The source of a scene that draws no things, as the `/ui` gallery's pages.
 */
export const NO_THINGS: ThingSource = Object.freeze({
  /**
   * Draws no thing.
   *
   * @returns False.
   */
  top: (): boolean => false,
});
